import { v4 as uuidv4 } from 'uuid';

export function Logo(props) {
	return {
		componentName: 'Logo',
		componentId: uuidv4(),
		props: Object.assign(
			{
				url: 'https://pbs.twimg.com/profile_images/1146057962386931716/5_puXcAD_400x400.png',
				href: '',
				title: 'Logo',
				height: '',
				width: '',
			},
			props,
		),
		childrenComponents: [],
	};
}
